// Environment configuration for UTrade MCP OAuth Dashboard

export interface AppConfig {
  backendUrl: string;
  frontendUrl: string;
  oauthProvider: string;
}

// Get environment variables with fallback to default values
const getEnvVar = (key: string, defaultValue: string): string => {
  return process.env[key] || defaultValue;
};

export const appConfig: AppConfig = {
  backendUrl: getEnvVar('REACT_APP_BACKEND_URL', 'https://snmcp.utradesolutions.dev'),
  frontendUrl: getEnvVar('REACT_APP_FRONTEND_URL', 'https://snmcp-dash.utradesolutions.dev'),
  oauthProvider: getEnvVar('REACT_APP_OAUTH_PROVIDER', 'ShareIndia'),
};

// Export individual config values for convenience
export const { backendUrl, frontendUrl, oauthProvider } = appConfig;
